export class NumberUtils {

  static round2Fixed(value): number {
    value = +value;

    if (isNaN(value)) {
      return NaN;
    }

    // Shift
    value = value.toString().split('e');
    value = Math.round(+(value[ 0 ] + 'e' + (value[ 1 ] ? (+value[ 1 ] + 2) : 2)));

    // Shift back
    value = value.toString().split('e');
    return Number((+(value[ 0 ] + 'e' + (value[ 1 ] ? (+value[ 1 ] - 2) : -2))).toFixed(2));
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/utils/number.util.ts